module.exports = __webpack_public_path__ + "static/AppleBadge-0c80ace1953c5c1f90764ff97fa71c5b.svg";